import { procurementAPI } from "../../axios";

export const actions = {

    // Item
    GetItem(){
        return procurementAPI.get(`Item/GetAllItems`);
    },
    GetItemByCampus(context, data){
        return procurementAPI.get(`Item/Campus/${data}`);
    },
    GetItemByCycle(context, data){
        return procurementAPI.get(`Item/Year/${data.cycle}/${data.campusId}`);
    },
    GetItemByTechRep(context, data){
        return procurementAPI.get(`Item/TechnicalReview/${data.campusId}/${data.cycle}`);
    },
    GetItemByAccount(context, data){
        return procurementAPI.get(`Item/Account/${data}`);
    },
    GetSingleItem(context, data){
        return procurementAPI.get(`Item/${data}`);
    },
    UpdateItem(context, data){
        return procurementAPI.put(`Item/${data.id}`, data);
    },
    DeleteItem(context, data){
        return procurementAPI.delete(`Item/${data}`);
    },
    CreateItem(context, data){
        return procurementAPI.post(`Item/CreateItem`, data);
    },
    CreateMultipleItem(context, data){
        return procurementAPI.post(`Item/Create/Multiple`, data);
    },
    SearchItem(context, data){
        return procurementAPI.post(`Item/Search/${data.campusId}/${data.year}/${data.lastId}`, data);
    },
    SemanticSearch(context, data){
        return procurementAPI.post(`Item/SemanticSearch/${data.campusId}/${data.year}`, data);
    }
}